var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NodeElement } from './base/node-element';
import * as go from '../../../../libs/gojs/release/go';
import { DiagramConsts } from '../diagram-consts';
var VideoElement = /** @class */ (function (_super) {
    __extends(VideoElement, _super);
    function VideoElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VideoElement.prototype.compile = function (model, data, svg) {
        svg.empty();
        model['version'] = 4;
        model['videoType'] = data.videoType;
        model['videoTag'] = data.videoTag;
        model['size'] = this.sizeService.parse(data.size);
        model['location'] = go.Point.parse(data.loc);
    };
    VideoElement.prototype.getPaletteTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', { width: 50, height: 90, locationSpot: go.Spot.Center }, $(go.Picture, { margin: 10, source: '/assets/common/images/configure/elements/video-small.png' }), $(go.TextBlock, {
            alignment: go.Spot.Center,
            text: this.l(this.getCategoryKey()),
            editable: false
        }));
    };
    VideoElement.prototype.getDiagramTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', {
            resizable: true, locationObjectName: 'IMAGE', locationSpot: go.Spot.TopLeft,
            selectionAdornmentTemplate: $(go.Adornment, 'Spot', $(go.Panel, go.Panel.Auto, $(go.Shape, { fill: null, stroke: 'dodgerblue', strokeWidth: 1 }, new go.Binding('stroke', 'locked', function (locked) { return locked ? '#f65177' : 'dodgerblue'; })), $(go.Placeholder)))
        }, new go.Binding('angle').makeTwoWay(), new go.Binding('movable', 'locked', function (locked) { return !locked; }), new go.Binding('resizable', 'locked', function (locked) { return !locked; }), new go.Binding('deletable', 'locked', function (locked) { return !locked; }), new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), new go.Binding('zOrder'), 
        // can be resided according to the user's desires
        { resizable: true, resizeObjectName: 'IMAGE' }, $(go.Panel, 'Spot', $(go.Picture, {
            name: 'IMAGE',
            source: '/assets/common/images/configure/elements/video-large.jpg'
        }, new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify))));
    };
    VideoElement.prototype.getCategoryKey = function () {
        return DiagramConsts.elements.videoKey;
    };
    return VideoElement;
}(NodeElement));
export { VideoElement };
